import { render, staticRenderFns } from "./BSDAuthorizationAgreement.vue?vue&type=template&id=42da9e84&scoped=true"
import script from "./BSDAuthorizationAgreement.vue?vue&type=script&lang=js"
export * from "./BSDAuthorizationAgreement.vue?vue&type=script&lang=js"
import style0 from "./BSDAuthorizationAgreement.vue?vue&type=style&index=0&id=42da9e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42da9e84",
  null
  
)

export default component.exports